<template>
  <div class="pay">
    <el-dialog title="服务订购"
               :visible.sync="dialogVisible"
               width="1048px"
               :before-close="handleClose">
      <div class="main">
        <el-steps :space="200"
                  :active="2"
                  finish-status="success"
                  align-center>
          <el-step title="选择服务"></el-step>
          <el-step title="确认账单"></el-step>
          <el-step title="确认付款"></el-step>
          <el-step title="完成订购"></el-step>
        </el-steps>
        <p>订单提交成功，请尽快支付！</p>
        <p>请您在7天内完成支付，否则订单会被自动取消</p>
        <div class="subtitle">
          <h4>订单买家： {{ !!$store.state.userInfo.identity_number ? $store.state.userInfo.real_name : $store.state.userInfo.company_name }}</h4>
          <p class="pay"
             v-if="itemData">
            应付款：<span>{{ itemData.amount }}</span> 元
          </p>
        </div>
        <div class="selpay">
          <div class="btn">
            <el-button class="selwx"
                       :type="selVal == 2 ? 'success' : ''"
                       round
                       @click="selBtn(2)"> <i class="icon-weixinzhifu iconfont"></i> 微信支付</el-button>
            <el-button class="selali"
                       :type="selVal == 1 ? 'primary' : ''"
                       round
                       @click="selBtn(1)"> <i class="icon-zhifubaozhifu iconfont"></i> 支付宝支付</el-button>
          </div>
          <div class="erweima right">
            <div class="img">
              <div class="div"
                   v-loading="urlLoad"
                   element-loading-text="加载中"
                   element-loading-spinner="el-icon-loading"
                   element-loading-background="rgba(0, 0, 0, 0.8)">
                <vue-qr :text="qrUrl"
                        qid="testid"
                        :margin="0"
                        v-if="qrUrl"></vue-qr>
                <div class="block"
                     v-else>
                  <el-image>
                    <div slot="error"
                         class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
              </div>
            </div>
            <p>请使用{{ selVal == 2 ? "微信" : "支付宝" }}支付，支付成功后自动开通服务</p>
          </div>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <!-- <p>合计： <span>5555.00</span> 元</p>
                <el-button type="primary" @click="dialogVisible = false">下一步</el-button> -->
      </span>
    </el-dialog>
    <div v-if="payVisible">
      <payResult @handleClose='inithandleClose'
                 :title='title'
                 :order_amount='order_amount'
                 :order_sn='order_sn'
                 :code='code'
                 ></payResult>

    </div>
  </div>
</template>

<script>
import VueQr from "vue-qr";
import { mapActions, mapGetters } from "vuex";
import payResult from './payResult.vue'
export default {
  name: "PayDia",
  data () {
    return {
      urlLoad: false,
      qrUrl: "",
      dialogVisible: false,
      payVisible: false,
      selVal: 1,
      timer: null,
      title: '',
      order_amount: "",
      order_sn: "",
      code:''
    };
  },
  components: { VueQr, payResult },
  computed: {
    ...mapGetters(["getToken"]),
  },
  props: ["itemData", "id"],
  methods: {
    inithandleClose () {
      this.payVisible = false
        clearInterval(this.timer);
    },
    ...mapActions({
      applicationOrder: "activity/applicationOrder",
      getPayment: "activity/getPayment",
      getPayQuery: "activity/getPayQuery",
    }),
    checkPay (id) {
      let opt = {
        id: id,
        token: this.getToken,
      };
      this.getPayQuery(opt).then(({ data }) => {
        if (data.code == 1) {
          //2
          if (data.data.status == 2) {
            clearInterval(this.timer);
            this.payVisible = true
            this.title = '支付成功'
            this.dialogVisible = false;
             this.order_amount=data.data.amount
             this.order_sn=data.data.order_sn
            this.code = data.data.code
            this.$emit("init");
          } else if (data.data.status == 3) {
            clearInterval(this.timer);
            this.payVisible = true
            this.title = '支付失败！'
              this.order_amount=data.data.amount
             this.order_sn=data.data.order_sn
             this.code = data.data.code
          }
        }
      });
    },
    Pay (id) {
      this.getPayment({ id: id }).then(({ data }) => {
        this.urlLoad = false;
        if (data.code == 1) {
          this.qrUrl = data.data.pay_url;
          if (!data.data.pay_url) {
            this.$message.warning("已提交过申请，请等待审核！");
            this.imgDialog = false;
          } else {
            this.qrUrl = data.data.pay_url;
            this.urlLoad = false;
            let i = 0;
            this.timer = setInterval(() => {
              this.checkPay(id);
              i++;
              if (i >= 20) {
                clearInterval(this.timer);
              }
            }, 3000);
          }
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    getPayId () {
      let params = {
        token: this.getToken,
        // id: this.id,
        // type: this.type,
        // price_id: this.item.amount[this.sle_index].id,
        id: this.id, //应用ID
        type: this.selVal, //支付类型 1-支付宝 2-微信
        price_id: 0, //价格id
        combo_id: this.itemData.id, //套餐id
      };
      this.urlLoad = true;
      this.applicationOrder(params).then(({ data }) => {
        if (data.code == 1) {
          if (data.data.payment_id == 0) {
            this.$emit("init");
         this.payVisible = true
            this.title = '支付成功'
            this.handleClose();
            return;
          }
          this.Pay(data.data.payment_id);
        } else {
          this.$message.error(data.msg);
          this.urlLoad = false;
        }
      });
    },
    selBtn (tag) {
      this.selVal = tag;
       clearInterval(this.timer)
      this.getPayId();
    },
    handleClose () {
      clearInterval(this.timer);
      this.qrUrl = "";
      this.urlLoad = false;
      this.dialogVisible = false;
      this.selVal = 1;
    },
  },
  beforeDestroy () {
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss" scoped>
.subtitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  h4 {
    font-size: 18px;
    color: #333;
    font-weight: 600;
    position: relative;
    padding-left: 20px;
    &::before {
      content: "";
      width: 3px;
      height: 18px;
      position: absolute;
      background: #2448ff;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
.main {
  height: 500px;
  margin: 40px 80px;
  & > p {
    line-height: 40px;
  }

  .selpay {
    display: flex;
    align-items: center;
    width: 100%;
    border: 1px solid #d3d3d3;
    padding: 40px;
    .btn {
      ::v-deep .el-button--medium {
        font-size: 16px;
      }
      .el-button {
        margin: 20px 0;
        width: 160px;
        i {
          margin-right: 4px;
          font-size: 20px;
          position: relative;
          top: 2px;
        }
      }
    }
    .erweima {
      margin-left: 80px;
      flex: 1;
      .img {
        text-align: center;
        .div {
          width: 140px;
        }
      }
      p {
        margin-top: 22px;
      }
    }
  }

  .el-steps {
    margin-bottom: 40px;
  }
  .el-button {
    display: block;
    margin-bottom: 22px;
  }
  .pay {
    margin: 22px 0;
    color: #333;
    font-size: 14px;
    font-weight: 600;
    span {
      color: #f42727;
      font-size: 20px;
    }
  }
  .list {
    display: flex;
    .item {
      margin: 20px;
      flex: 1;
      background: #ffffff;
      border: 1px solid #d4d4d4;
      border-radius: 2px;
    }
  }
}
::v-deep .el-table th.el-table__cell {
  background-color: rgb(249, 249, 251);
}
::v-deep .dialog-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  p {
    margin-right: 40px;
    span {
      color: red;
    }
  }
}
::v-deep .el-dialog__body {
  padding: 0;
}

.right {
  .img {
    margin-left: 60px;
    img,
    .el-image {
      width: 140px;
      height: 140px;
      background: #eee;
      font-size: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .price_right {
    text-align: left;
    h4 {
      font-size: 18px;
      margin-bottom: 14px;
      span {
        font-size: 24px;
      }
    }
    p {
      padding-left: 4px;
      font-size: 14px;
    }
  }
}
</style>